import { i18nTranslate } from 'common/helper/i18n/translate';

const filtersUtilsGetIntervals: (selectedItems: Array<any>) => Array<Array<any>> = (selectedItems) =>
  selectedItems.reduce(
    (result, current) => {
      const lastInterval = result.intervals[result.intervals.length - 1];

      if (lastInterval) {
        if (Number(current.value) - Number(lastInterval[lastInterval.length - 1].value) === 1) {
          if (lastInterval.length === 2) {
            lastInterval[lastInterval.length - 1] = current;
          } else {
            lastInterval.push(current);
          }
        } else {
          result.intervals.push([current]);
        }
      } else {
        result.intervals.push([current]);
      }

      return result;
    },
    { intervals: [] as Array<typeof selectedItems> }
  ).intervals;

export const createAlertCardGetFilterValue = (
  filterValue: string[],
  filterOptions: any[] = [
    { value: '0' },
    { value: '1' },
    { value: '2' },
    { value: '3' },
    { value: '4' },
    { value: '5' },
    { value: '6' },
    { value: '7' },
    { value: '8' },
  ]
): string => {
  if (filterValue.length === 1 && filterValue[0] === String('1')) {
    return filterValue[0];
  }

  let message: string = '';

  const bedroomsSet = new Set<string>(filterValue);

  // if studio was selected
  if (bedroomsSet.has('0')) {
    message += i18nTranslate('Studio');
    bedroomsSet.delete('0');
  }
  const selectedBedrooms = filterOptions.filter((item) => bedroomsSet.has(item.value));

  const intervals = filtersUtilsGetIntervals(selectedBedrooms);

  intervals.forEach((interval) => {
    if (message) {
      message += ', ';
    }

    message += interval
      .map((item) =>
        item.value === filterOptions[filterOptions.length - 1].value && item.value === String('8') ? '7+' : item.value
      )
      .join(' - ');
  });

  return message;
};
